import FormValidatorText from './FormValidatorText';
import FormValidatorEmail from './FormValidatorEmail';
import FormValidatorTextarea from './FormValidatorTextarea';
import FormValidatorSelect from './FormValidatorSelect';
import FormValidatorCheckbox from './FormValidatorCheckbox'
import FormValidatorPassword from './FormValidatorPassword';

export default {
  install(Vue) {
    Vue.component('FormValidatorText', FormValidatorText);
    Vue.component('FormValidatorEmail', FormValidatorEmail);
    Vue.component('FormValidatorTextarea', FormValidatorTextarea);
    Vue.component('FormValidatorSelect', FormValidatorSelect);
    Vue.component('FormValidatorCheckbox', FormValidatorCheckbox);
    Vue.component('FormValidatorPassword', FormValidatorPassword);
  },
};
